import React from "react";
import ReactHtmlParser from "react-html-parser";
export default function InfoSection({
  title,
  subtitle,
  description,
  subdescription,
  buttonText,
  buttonAction,
  image,
  imageCaption,
  multiImageCaption,
  rightTitle,
  rightDescription,
  features = [],
  rightDescriptionSecondHeading,
  rightDescriptionSecond,
  featuresSecond = [],
  footerText,
}) {
  return (
    <div className="custom-container py-5">
      <div className="row align-items-center gap-5">
        {/* LEFT SECTION */}
        <div className="col-lg-5 mb-4 mb-lg-0">
          {/* TITLE */}
          <h4
          className="text-success fst-italic mb-2 FS40FW600"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <h2 className="top-section-text FS40FW600 mb-5">{subtitle}</h2>

          {/* IMAGE */}
          <div className="mb-3">
            <img
              src={image}
              alt="preview"
              className="img-fluid rounded-4 w-100"
            />
          </div>

          {/* IMAGE CAPTION */}
          {imageCaption && (
            <p className="quote-box mt-3 FS18FW400 black">{ReactHtmlParser(imageCaption)}</p>
          )}

          {/* MULTI-IMAGE CAPTION */}
          {multiImageCaption && (
            multiImageCaption.map((item, i) => (
              <p key={i} className="quote-box mt-3 FS18FW400 black">
                {item}
              </p>
            ))
          )}
        </div>

        {/* RIGHT SECTION */}
        <div className="col-lg-6">
          {/* DESCRIPTION */}
          <p className="mb-3 plus-sans FS16FW500">{description}</p>

          

          {/* BUTTON */}
          {buttonText && (
            <button className="primary-btn mb-4" onClick={buttonAction}>
              {buttonText}  <img src={`/images/web-new-images/right-arrow.svg`} alt="Register Now" />
            </button>
          )}

          {/* CARD */}
          <div className="p-4 rounded-4 border">
            {subdescription && (
            <p className="mb-3 plus-sans FS12">{subdescription}</p>
          )}
            <h5 className="plus-sans FS24FW500 fw-700 mb-3">{rightTitle}</h5>

            <p className="quote-box mt-3 FS18FW400 ps-3">{rightDescription}</p>

            {/* FEATURES */}
            {features.map((item, i) =>
              typeof item === "string" ? (
                <ul key={i} className="feature-list">
                  <li className="mb-2 d-flex align-items-start FS16FW500 fw-normal">
                    <span dangerouslySetInnerHTML={{ __html: item }} />
                  </li>
                </ul>
              ) : (
                <div key={i} className="mb-3">
                  <h6 className="plus-sans FS16FW500 fw-700 mb-2" style={{ textTransform: 'none' }}>{item.title}</h6>
                  <ul className="feature-list">
                    {item.items.map((tick, j) => (
                      <li key={j} className="mb-2 d-flex align-items-start FS16FW500 fw-normal">
                        <span>{tick}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            )}

            {rightDescriptionSecondHeading && (
              <p className="quote-box">{rightDescriptionSecondHeading()}</p>
           )}

            <p className="plus-sans FS24FW500 fw-700 mb-3">{rightDescriptionSecond}</p>
            
             <ul className="feature-list">
              {featuresSecond.map((item, i) => (
                <li key={i} className="mb-2 d-flex align-items-start FS16FW500 fw-normal">
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </li>
              ))}
            </ul>

            {/* FOOTER TEXT */}
            {footerText && (
              <p className="mt-3 small text-muted border-top pt-3">
                {ReactHtmlParser(footerText)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
